import { Divider } from '@chakra-ui/react';
import type { DividerBlock as DividerBlockType } from '../../editor/types';
import { ADMIN_COLORS } from '../../../../../../generated/tokens/constants';

type DividerBlockProps = DividerBlockType['props'];

export function DividerBlock({
  style = 'solid',
  color_token,
}: DividerBlockProps): React.ReactElement {
  return (
    <Divider
      gc-testing-id="blockDivider"
      borderStyle={style}
      borderColor={color_token ?? ADMIN_COLORS.border}
    />
  );
}
